export default __webpack_public_path__ + "25b9f85b766eb919e1e4f1a3fc539361.jpg";